import "./PieChart.css";

import { Doughnut } from "react-chartjs-2";

import { ChartDataWithSuffix, ChartProps, PieChartCenterTextFont, PieChartColors } from "../models";
import { maybeSetGlobalChartJsConfiguration } from "../utils";
import { ChartLegend, ChartLegendWithSuffix } from ".";
import { usePieChart } from "./usePieChart";

maybeSetGlobalChartJsConfiguration();

type PieChartVariant = "Primary" | "Secondary";

export interface PieChartProps extends ChartProps {
  size: number;
  variant?: PieChartVariant;
  centerTextSuffix?: string;
  centerTextPrefix?: string;
  centerTextHidden?: boolean;
  centerTextFont?: PieChartCenterTextFont;
  noDataMessage?: string;
  hasSuffix?: boolean;
  dataWithSuffix?: ChartDataWithSuffix;
  isGradient?: boolean;
  direction?: "Horizontal" | "Vertical";
  colors?: PieChartColors;
  chartColorsOverride?: string[][];
  showValues?: boolean;
  defaultLegendValue?: string | null;
}

export const PieChart = ({
  data,
  size,
  variant = "Primary",
  centerTextPrefix,
  centerTextSuffix,
  centerTextHidden = false,
  centerTextFont = "Space Grotesk",
  noDataMessage = "No data",
  hasSuffix = false,
  dataWithSuffix,
  isGradient = false,
  direction = "Horizontal",
  colors = "default",
  chartColorsOverride,
  showValues = true,
  defaultLegendValue = null,
}: PieChartProps): JSX.Element => {
  const { chartData, legendData, chartColours, plugins, options, hasData, pieChartRef } = usePieChart(
    data,
    centerTextPrefix,
    centerTextSuffix,
    centerTextHidden,
    centerTextFont,
    noDataMessage,
    isGradient,
    colors,
    chartColorsOverride
  );

  return (
    <>
      {plugins && (
        <div className={`PieChart ${variant} ${direction}`}>
          <div className="Chart" style={{ maxWidth: size, maxHeight: size }}>
            <Doughnut ref={pieChartRef} data={chartData} options={options} plugins={plugins} />
          </div>
          {hasSuffix && dataWithSuffix ? (
            <ChartLegendWithSuffix
              colours={chartColours}
              hasData={hasData}
              defaultValue={defaultLegendValue}
              data={dataWithSuffix}
              showValues={showValues}
            />
          ) : (
            <ChartLegend
              data={legendData}
              colours={chartColours}
              hasData={hasData}
              defaultValue={defaultLegendValue}
              variant={variant}
              showValues={showValues}
            />
          )}
        </div>
      )}
      {(data === null || data === undefined || Object.values(data).length === 0) && (
        <div className={`PieChart ${variant} ${direction}`}>
          <div className="Chart" style={{ maxWidth: size, maxHeight: size }}>
            <Doughnut ref={pieChartRef} data={chartData} options={options} />
          </div>
          {hasSuffix && dataWithSuffix ? (
            <ChartLegendWithSuffix
              colours={chartColours}
              hasData={hasData}
              defaultValue={defaultLegendValue}
              data={dataWithSuffix}
              showValues={showValues}
            />
          ) : (
            <ChartLegend
              data={legendData}
              colours={chartColours}
              hasData={hasData}
              defaultValue={defaultLegendValue}
              variant={variant}
              showValues={showValues}
            />
          )}
        </div>
      )}
    </>
  );
};
